import gql from 'graphql-tag'

export const operationCounterCycleCreate = gql`
  mutation operationCounterCycleCreate($data: OperationCounterCycleCreateInput!) {
    operationCounterCycleCreate(input: $data) {
      success
    }
  }
`
